import React, { useState, useEffect, useCallback } from "react";
import "./AddProjectType.css";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import Header from "../../../Components/Dashboard/Header/Header";
import { GetToken, Apiurl } from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Modal } from "react-bootstrap";

const AddProjectType = () => {
  const [showSidebar, setShowSidebar] = useState(true);
  const [projectType, setProjectType] = useState("");
  const [projectTypes, setProjectTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editingName, setEditingName] = useState("");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteName, setDeleteName] = useState("");

  const getHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${GetToken()}`,
  });

  const getProjectTypeId = (item) =>
    item?.Id ||
    item?.id ||
    item?.ProjectTypeId ||
    item?.projectTypeId ||
    item?.ProjectTypeID ||
    item?.project_type_id;

  const getProjectTypeName = (item) =>
    item?.ProjectType1 ||
    item?.projectType1 ||
    item?.Name ||
    item?.name ||
    item?.ProjectTypeName ||
    item?.projectTypeName ||
    "N/A";

  const fetchProjectTypes = useCallback(async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${Apiurl()}/Projects/GetAllProjectTypes`,
        { headers: getHeaders() }
      );

      let data =
        response?.data?.data ||
        response?.data?.Data ||
        response?.data?.result ||
        response?.data?.Result ||
        response?.data;

      if (typeof data === "string") {
        data = JSON.parse(data);
      }

      if (!Array.isArray(data)) {
        data = data ? [data] : [];
      }

      setProjectTypes(data);
    } catch (error) {
      console.log("GET ERROR:", error?.response || error);
      setProjectTypes([]);
      toast.error("Failed to load project types");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProjectTypes();
  }, [fetchProjectTypes]);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setShowSidebar(false);
    }
  }, []);

  const handleSave = async () => {
    if (!projectType.trim()) {
      toast.error("Please enter project type");
      return;
    }

    setLoading(true);

    try {
      const url = `${Apiurl()}/Projects/AddProjectType?name=${encodeURIComponent(
        projectType.trim()
      )}`;

      const response = await axios.post(url, null, {
        headers: getHeaders(),
      });

      if (response?.status === 200) {
        toast.success("Saved Successfully");
        setProjectType("");
        fetchProjectTypes();
      }
    } catch (error) {
      console.log("SAVE ERROR:", error?.response || error);
      toast.error(error?.response?.data?.message || "Failed to save");
    } finally {
      setLoading(false);
    }
  };

  const handleEditOpen = (item) => {
    const id = getProjectTypeId(item);
    const name = getProjectTypeName(item);

    if (!id) {
      toast.error("Project type ID not found");
      return;
    }

    setEditId(id);
    setEditingName(name === "N/A" ? "" : name);
    setShowEditModal(true);
  };

  const handleUpdate = async () => {
  if (!editId) {
    toast.error("Project type ID not found");
    return;
  }

  if (!editingName.trim()) {
    toast.error("Please enter project type");
    return;
  }

  setLoading(true);

  try {
    const payload = {
      id: Number(editId),
      name: editingName.trim(),
    };

    const response = await axios.put(
      `${Apiurl()}/Projects/UpdateProjectType`,
      payload,
      {
        headers: getHeaders(),
      }
    );

    if (response?.status === 200) {
      toast.success("Updated Successfully");
      setShowEditModal(false);
      setEditId(null);
      setEditingName("");
      fetchProjectTypes();
    }
  } catch (error) {
    console.log("UPDATE ERROR:", error?.response || error);
    toast.error(error?.response?.data?.message || "Update failed");
  } finally {
    setLoading(false);
  }
};

  const handleDeleteOpen = (item) => {
    const id = getProjectTypeId(item);
    const name = getProjectTypeName(item);

    if (!id) {
      toast.error("Project type ID not found");
      return;
    }

    setDeleteId(id);
    setDeleteName(name);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
  if (!deleteId) {
    toast.error("Project type ID not found");
    return;
  }

  setLoading(true);

  try {
    const payload = {
      id: Number(deleteId),
    };

    const response = await axios.delete(
      `${Apiurl()}/Projects/DeleteProjectType`,
      {
        headers: getHeaders(),
        data: payload,
      }
    );

    if (response?.status === 200) {
      toast.success("Deleted Successfully");
      setShowDeleteModal(false);
      setDeleteId(null);
      setDeleteName("");
      fetchProjectTypes();
    }
  } catch (error) {
    console.log("DELETE ERROR:", error?.response || error);
    toast.error(error?.response?.data?.message || "Delete failed");
  } finally {
    setLoading(false);
  }
};
  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "main-container-of-all-employees-page-annoucement"
              : "main-container-of-all-employees-page-annoucement-new"
          }
        >
          <div className="admin-page-content">
            <div className="subdept-header-container">
              <div className="all-employee-text-annoucement">
                <h4>Project Type</h4>
              </div>

              <div className="all-employees-directory-annoucement">
                <BiHomeAlt />
                <MdKeyboardArrowRight />
                <p>Dashboard</p>
                <MdKeyboardArrowRight />
                <p>Add Project Type</p>
              </div>
            </div>

            <div className="outer-div-of-username-password-annoucement">
              <div className="security-annoucement">
                <h5>Manage Project Type</h5>
              </div>

              <div className="username-password-announcement">
                <div className="row">
                  <div className="col-md-6 username-content-annoucement">
                    <label>Project Type Name</label>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Project Type"
                      value={projectType}
                      onChange={(e) => setProjectType(e.target.value)}
                    />
                  </div>
                </div>

                <div className="save-button-in-setting-annoucement mt-3">
                  <button
                    className="btn btn-success me-2"
                    onClick={handleSave}
                    disabled={loading}
                  >
                    Save
                  </button>

                  <button
                    className="btn btn-secondary"
                    onClick={() => setProjectType("")}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                </div>
              </div>

              <div className="department-table-container mt-4">
                <h5 style={{ textAlign: "center" }}>Project Type List</h5>

                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Project Type Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="3" align="center">
                            Loading...
                          </td>
                        </tr>
                      ) : projectTypes.length > 0 ? (
                        projectTypes.map((item, index) => (
                          <tr key={getProjectTypeId(item) || index}>
                            <td>{getProjectTypeId(item)}</td>
                            <td>{getProjectTypeName(item)}</td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm me-2"
                                onClick={() => handleEditOpen(item)}
                                disabled={loading}
                              >
                                Edit
                              </button>

                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleDeleteOpen(item)}
                                disabled={loading}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" align="center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showEditModal}
        onHide={() => {
          setShowEditModal(false);
          setEditId(null);
          setEditingName("");
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Project Type</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <input
            type="text"
            className="form-control"
            value={editingName}
            onChange={(e) => setEditingName(e.target.value)}
          />
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setShowEditModal(false);
              setEditId(null);
              setEditingName("");
            }}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className="btn btn-success"
            onClick={handleUpdate}
            disabled={loading}
          >
            {loading ? "Updating..." : "Update"}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
          setDeleteId(null);
          setDeleteName("");
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure delete <b>{deleteName}</b>?
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setShowDeleteModal(false);
              setDeleteId(null);
              setDeleteName("");
            }}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className="btn btn-danger"
            onClick={handleDelete}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddProjectType;